import React, {useEffect, useState} from 'react';
import css from './Profile.module.scss'
import {NavLink, Redirect, Route} from "react-router-dom";
import Licenses from "./Licenses/Licenses";
import '../../../styles/index.scss'
import MainContainer from "../MainContainer";
import dots from '../../../images/submenu.svg'
import avatar from '../../../images/user-placeholder.png'
import {Field, Formik} from "formik";
import InputMask from 'react-input-mask'
import Yachts from "./Yachts/Yachts";
import Command from "./Command/Command";
import Resume from "./Resume/Resume";
import {useTheme} from "../../../App";
import {connect} from "react-redux";
import {deleteProfile, sendConfirmEmail, updateProfile, uploadFile} from "../../../redux/user/user-thunks";
import ChangePassword from "../../common/modals/ChangePassword";
import {withRouter} from "react-router";
import withAuthRedirect from "../../common/hoc/withCheckAuth";
import {userApi} from "../../../redux/user/user-api";
import {setIsPasswordReseted, setProfile, setUser} from "../../../redux/user/user-actions";
import close from "../../../images/close.svg";
import camera from '../../../images/camera.svg'
import darkItem1 from "../../../images/white_key.svg";
import item1 from "../../../images/key.svg";
import darkItem2 from "../../../images/white_small-exit.svg";
import item2 from "../../../images/small-exit.svg";
import darkItem4 from "../../../images/white_trash.svg";
import item4 from "../../../images/trash.svg";
import {setToken} from "../../../redux/auth/auth-actions";
import {getTrips} from "../../../redux/logbook/logbook-thunks";
import Input from 'react-phone-number-input/input'
import infoIcon from "../../../images/info-circle.svg";
import ReactTooltip from "react-tooltip";
import withCheckAuth from "../../common/hoc/withCheckAuth";
import ConfirmEmail from "../../common/modals/ConfirmEmail";
import {useTranslation} from "react-i18next";
import ProfileDelete from "./ProfileDelete/ProfileDelete";
import {fromDateToStringDate, fromStringDateToDate} from "../../../utils";

const ProfileContainer = ({isDark, setTheme, user, profile, updateProfile, isPasswordReseted, ...props}) => {
  const [isShowTost, setIsShowTost] = useState(false)
  const [file, setFile] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [isChangePassword, setIsChangePassword] = useState(false)
  const [isLogout, setIsLogout] = useState(false)
  const [isShowConfirmEmail, setIsShowConfirmEmail] = useState(false)
  const {t} = useTranslation()
  const links = [
    {
      name: t('licenses'),
      link: '/profile/licenses'
    },
    {
      name: t('favYachts'),
      link: '/profile/yachts'
    },
    {
      name: t('myTeam'),
      link: '/profile/command'
    },
    {
      name: t('resume'),
      link: '/profile/resume'
    },
  ]
  useEffect(() => {
    if(props.location.search.length > 0) {
      setIsChangePassword(true)
    }
  }, [])
  useEffect(() => {
    if(user) {
      // props.getTrips()
    }
  }, [user])
  const recoveryPassword = async () => {
    await userApi.recoveryPassword(user.email)
    setIsShowTost(true)
  }
  if(isPasswordReseted) {
    props.setIsPasswordReseted(undefined)
    return <Redirect to={'/profile/licenses'} />
  }
  const logout = () => {
    localStorage.removeItem('token')
    props.setToken(false)
    setIsLogout(true)
    props.setUser(null)
    props.setProfile(null)
  }
  if(isLogout) {
    return <Redirect to={'/auth'} />
  }

  return (
    <MainContainer isDark={isDark} setTheme={() => setTheme(!isDark)}>
      {(isChangePassword || isShowConfirmEmail) && <div className={'overlay'} />}
      {isChangePassword && <ChangePassword closeModal={() => setIsChangePassword(false)} isDark={isDark} token={props.location.search.split('=')[1]} />}
      {isShowConfirmEmail && <ConfirmEmail isDark={isDark} closeModal={() => setIsShowConfirmEmail(false)}
      onSubmit={() => {
        props.sendConfirmEmail()
        setIsShowConfirmEmail(false)
      }}/>}
      {isShowTost && <button className={'tost'}>
        {t('sentEmailForPassword')}
        <button onClick={() => setIsShowTost(false)} className={'tost__close'}>
          <img src={close} alt=""/>
        </button>
      </button>}
      {isPasswordReseted === undefined && <button className={'tost'}>
        {t('passwordChanged')}
        <button onClick={() => props.setIsPasswordReseted(false)} className={'tost__close'}>
          <img src={close} alt=""/>
        </button>
      </button>}
      {isPasswordReseted === null && <button style={{background: '#EB5757', color: 'white'}} className={'tost'}>
        {t('errorPassword')}
        <button onClick={() => props.setIsPasswordReseted(false)} className={'tost__close'}>
          <img src={close} alt=""/>
        </button>
      </button>}
      <div className={`${css.profile} ${isDark && css.profile__dark}`}>
        <div className={css.profile__col}>
          <h3 className={css.profile__title}>{t('myProfile')}</h3>
          <div className={css.info}>
            <div className={css.info__title}>
              <p className={css.info__caption}>
                Info
              </p>
              <button className={`${css.info__dots} submenuTrig`}>
                <img src={dots} alt=""/>
              </button>
              <div className={`submenu ${css.profile__submenu} ${isDark && 'submenu__dark'}`}>
                <button onClick={recoveryPassword} className={'submenuItem'}>
                  <img src={isDark ? darkItem1 : item1} alt="" className={'submenuIcon'}/>
                  {t('changePassword')}
                </button>
                <button onClick={logout} className={'submenuItem'}>
                  <img src={isDark ? darkItem2 : item2} alt="" className={'submenuIcon'}/>
                  {t('signOut')}
                </button>
                <NavLink to={'/logbook/profile/delete'} className={'submenuItem'}>
                  <img src={isDark ? darkItem4 : item4} alt="" className={'submenuIcon'}/>
                  {t('deleteAc')}
                </NavLink>
              </div>
            </div>
            <div className={css.info__imgWrapper}>
              <img src={file !== null ? URL.createObjectURL(file) : (profile?.image_link ? `data:image/png;base64,${profile?.image_link}` : avatar)} alt="" className={css.info__avatar}/>
              <input onChange={(e) => setFile(e.target.files[0])} type="file" className={css.info__file} id={'avatar'}/>
              {isEdit && <label className={css.info__avatarPlaceholder} htmlFor="avatar">
                <img src={camera} alt=""/>
              </label>}
            </div>
            {!isEdit && <>
              <p className={css.info__name}>{profile?.first_name} {profile?.last_name}</p>
              <p className={css.info__birth}>{profile?.birth_date ? fromDateToStringDate(profile.birth_date) : ''}</p>
              <div className={css.info__stats}>
                <div className={css.info__stat}>
                  <p className={css.info__number}>{props.experience?.miles ?? 0}</p>
                  <p className={css.info__text}>{t('nauticalMiles')}</p>
                </div>
                <div className={css.info__stat}>
                  <p className={css.info__number}>{props.experience?.days ?? 0}</p>
                  <p className={css.info__text}>{t('daysInTheSea')}</p>
                </div>
              </div>
            </>}
            {user !== null && profile !== null && <Formik
              initialValues={{
                email: user.email,
                phone: profile.phone_number,
                firstName: profile.first_name,
                lastName: profile.last_name,
                birth_date: fromDateToStringDate(profile.birth_date)
              }}
              onSubmit={({firstName, lastName, phone, birth_date}) => {
                setIsEdit(false)
                if(file !== null) {
                  props.uploadFile(file)
                  setFile(null)
                }
                updateProfile(firstName, lastName, phone, fromStringDateToDate(birth_date))
              }}
            >
              {({values, handleChange, handleSubmit, setFieldValue}) => {
                return <>
                  <div className={css.info__data}>
                    {isEdit && <>
                      <div className={`${css.info__col} w-100`}>
                        <p className={css.info__label}>{t('name')}</p>
                        <Field id={'firstName'} type={'firstName'} required={true}
                               value={values.firstName} onChange={handleChange}
                               className={`modal__input w-100 mb-12 ${css.info__value}`}/>
                      </div>
                      <div className={`${css.info__col} w-100`}>
                        <p className={css.info__label}>{t('surname')}</p>
                        <Field id={'lastName'} type={'lastName'} required={true}
                               value={values.lastName} onChange={handleChange}
                               className={`modal__input w-100 mb-12 ${css.info__value}`}/>
                      </div>
                      <div className={`${css.info__col} w-100`}>
                        <p className={css.info__label}>{t('birthDate')}</p>
                        <InputMask mask={'99.99.9999'} maskChar={''} id={'birth_date'} type={'birth_date'}
                               value={values.birth_date} onChange={handleChange}
                               className={`modal__input w-100 mb-12 ${css.info__value}`}/>
                      </div>
                    </>}
                    <div className={`${css.info__col} w-100`}>
                      <p className={css.info__label}>{t('email')}</p>
                      {isEdit ? <Field id={'email'} type={'email'} required={true}
                                       value={values.email} onChange={handleChange}
                                       className={`modal__input w-100 mb-12 ${css.info__value}`}/>
                        : <>
                          <p style={{color: user?.is_active ? '' : '#EB5757'}} className={`${css.info__value} m-0`}>{values.email} {!user.is_active && <>
                            <button data-tip data-for={'email-un-active'} className="modal__infoButton">
                              <img src={infoIcon} alt=""/>
                            </button>
                            <ReactTooltip className={`${isDark && 'tooltip tooltip__dark'}`}
                                          backgroundColor={isDark ? '#FFFFFF' : '#52616E'}
                                          id={'email-un-active'} place="top" effect="solid">
                              {t('notConfirmed')}
                            </ReactTooltip>
                          </>}</p>
                          {!user.is_active && <button onClick={() => setIsShowConfirmEmail(true)} className={'blueText-button pl-0'}>
                            {t('sendConfirmation')}
                          </button>}
                        </>}
                    </div>
                    {(profile.phone_number || isEdit) && <div className={`${css.info__col} w-100`}>
                      <p className={css.info__label}>{t('phone')}</p>
                      {isEdit ? <Input id={'phone'} value={values.phone} onChange={e => setFieldValue('phone', e)}
                                           className={`modal__input w-100 ${css.info__value}`}/> :
                        <p className={css.info__value}>{values.phone}</p>}
                    </div>}
                    {isEdit && <button onClick={recoveryPassword} className={'blueText-button'}>
                      {t('changePassword')}
                    </button>}
                  </div>
                  <div className={css.info__imgWrapper}>
                    {isEdit ? <button type={'submit'} onClick={handleSubmit} className="submit-button w-100">
                        {t('save')}
                      </button> :
                      <button onClick={() => {
                        if(user?.is_active) {
                          setIsEdit(true)
                        } else {
                          setIsShowConfirmEmail(true)
                        }
                      }} className={`commonBtn mt-24 ${isDark && 'commonBtn__dark'}`}>
                        <span className="commonBtn__label">{t('editProfile')}</span>
                      </button>}
                  </div>
                </>
              }}
            </Formik>}
          </div>
        </div>
        <div className={css.profile__col}>
          <ul className={css.profile__menu}>
            {links.map((link, index) => <li key={index} className={css.profile__linkWrapper}>
              <NavLink to={`/logbook${link.link}`} className={css.profile__link}
                       activeClassName={css.profile__linkActive}>{link.name}</NavLink>
            </li>)}
          </ul>
          <div className={css.profile__content}>
            <Route path={'/logbook/profile/licenses'} render={() => <Licenses openConfirmEmail={() => setIsShowConfirmEmail(true)} isDark={isDark}/>}/>
            <Route path={'/logbook/profile/yachts'} render={() => <Yachts openConfirmEmail={() => setIsShowConfirmEmail(true)} isDark={isDark}/>}/>
            <Route path={'/logbook/profile/command'} render={() => <Command isDark={isDark}/>}/>
            <Route path={'/logbook/profile/resume'} render={() => <Resume isDark={isDark}/>} />
            <Route path={'/logbook/profile/delete'} render={() => <ProfileDelete isDark={isDark}/>} />
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  profile: state.userReducer.profile,
  isPasswordReseted: state.userReducer.isPasswordReseted,
  trips: state.logbookReducer.trips,
  experience: state.logbookReducer.experience
})

export default connect(mapStateToProps,
  {updateProfile, setIsPasswordReseted, uploadFile, setToken,
    setUser, setProfile, getTrips, sendConfirmEmail})(withCheckAuth(React.memo(withRouter(ProfileContainer))));
